import { render } from "./SupplierListComponent.vue?vue&type=template&id=71138601"
import script from "./SupplierListComponent.vue?vue&type=script&lang=js"
export * from "./SupplierListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Supplier/SupplierListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71138601"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71138601', __exports__)) {
    api.reload('71138601', __exports__)
  }
  
  module.hot.accept("./SupplierListComponent.vue?vue&type=template&id=71138601", () => {
    api.rerender('71138601', render)
  })

}


export default __exports__